import { openDB } from 'idb';
import { utf8_to_b64 } from '@iso/lib/helpers/utility';

const tenantId = localStorage.getItem('tenantId');

let MyDatabase = `P7OfflineDatabase_${tenantId}`;

let OrdersTable = 'Orders';
let ClientsTable = 'Clients';
let ConfigsTable = 'Configs';
let ProductsTable = 'Products';
let OrdersIndex = 'idxOrderStatus';

let PaymentFormsTable = 'PaymentForms';
let PaymentConditionsTable = 'PaymentConditions';

export const initDB = async () => {
    let db = openDB(MyDatabase, 1, {
        upgrade(db) {
            let store;

            if (!db.objectStoreNames.contains(ProductsTable))
                db.createObjectStore(ProductsTable, { keyPath: '_id' });

            if (!db.objectStoreNames.contains(OrdersTable)) {
                store = db.createObjectStore(OrdersTable, { keyPath: 'local_id' , autoIncrement: true });
                store.createIndex(OrdersIndex, 'status', { unique: false });
            }

            if (!db.objectStoreNames.contains(ClientsTable))
                db.createObjectStore(ClientsTable, { keyPath: '_id' });

            if (!db.objectStoreNames.contains(ConfigsTable))
                db.createObjectStore(ConfigsTable, { keyPath: '_id' });

            if (!db.objectStoreNames.contains(PaymentFormsTable))
                db.createObjectStore(PaymentFormsTable, { keyPath: '_id' });

            if (!db.objectStoreNames.contains(PaymentConditionsTable))
                db.createObjectStore(PaymentConditionsTable, { keyPath: '_id' });
        },
    });

    // await requestPersistentStorage();

    return db;
}

async function requestPersistentStorage() {
    if (navigator.storage && navigator.storage.persist) {
        // let isPersisted = await navigator.storage.persist();
        // if (isPersisted) {
        //     console.log('Storage will not be cleared except by explicit user action');
        // } else {
        //     console.log('Storage may be cleared under storage pressure.');
        // }
    } else {
        console.log('Persistent storage is not supported by this browser.');
    }
}

export const getItem = async (table, key) => {
    let db = await initDB();
    let tx = db.transaction(table, 'readonly');
    let store = tx.objectStore(table);
    let existingItem = await store.get(key);
    await tx.done;
    return existingItem;
}

export const doesKeyExist = async (table, key) => {
    let existingItem = await getItem(table, key)
    return existingItem !== undefined;
}

export const addItem = async (table, item, key) => {
    let db = await initDB();

    let keyExists = await doesKeyExist(table, item[key]);

    if (!keyExists) {
        let tx = db.transaction(table, 'readwrite');
        let store = tx.objectStore(table);
        // item = utf8_to_b64(JSON.stringify(item));
        let id = await store.add(item);
        await tx.done;
        return id;
    }
    else
        await updateItem(table, item[key], item);
}

export const getItems = async (table, filter) => {
    let db = await initDB();
    let tx = db.transaction(table, 'readonly');
    let store = tx.objectStore(table);
    let items;
    if(filter) {
        let index = store.index(OrdersIndex);
        items = await index.getAll(filter);
    }
    else 
        items = await store.getAll();
    await tx.done;
    return items;
}

export const updateItem = async (table, id, updatedItem) => {
    let db = await initDB();
    let tx = db.transaction(table, 'readwrite');
    let store = tx.objectStore(table);
    // updatedItem = utf8_to_b64(JSON.stringify(updatedItem));
    await store.put({ ...updatedItem, id });
    await tx.done;
}

export const deleteItem = async (table, id) => {
    let db = await initDB();
    let tx = db.transaction(table, 'readwrite');
    let store = tx.objectStore(table);
    await store.delete(id);
    await tx.done;
}